import React, { useState } from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { Col } from "react-bootstrap";
import {
  AutoCompleteField,
  form,
  FormInput,
  Form as AppForm
} from "MODULES/shared/components/Forms";
import * as actions from "MODULES/Consignments/actions";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { ADMIN, BUYER_ID, CO_BUYER_ID } from "MODULES/users/constants";
import { COMPANY_ID, CONSIGNOR_PERCENTAGE } from "APP_ROOT/constants";
import LocationRadioField from "MODULES/Locations/components/BuyingStoreRadioField";
import {
  STORE_LOCATION_ID,
  STORE_OWNER_ID
} from "MODULES/inventories/constants";
import PaymentTerms from "MODULES/shared/components/PaymentTerms/PaymentTerms";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { useCurrentUser } from "APP_ROOT/hooks";

export function Form(props) {
  const [selectedBuyer, _setSelectedBuyer] = useState(props.buyer);
  const [selectedCoBuyer, _setSelectedCoBuyer] = useState(props.coBuyer);
  const [selectedCompany, _setSelectedCompany] = useState(props.company);

  const currentUser = useCurrentUser();
  const isAdmin = currentUser && currentUser.role === ADMIN;

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={4}>
            <Field
              name={BUYER_ID}
              label="Buyer"
              placeholder="Search by name..."
              component={AutoCompleteField}
              search={props.searchBuyers}
              selectedItem={selectedBuyer}
              formatItem={result => result && result.full_name}
              required
            />
          </Col>
          <Col md={4}>
            <Field
              name={CO_BUYER_ID}
              label="Co Buyer"
              placeholder="Search by name..."
              component={AutoCompleteField}
              search={props.searchBuyers}
              selectedItem={selectedCoBuyer}
              formatItem={result => result && result.full_name}
            />
          </Col>
          <Col md={4}>
            <Field
              name={COMPANY_ID}
              label="Company"
              placeholder="Search by name..."
              component={AutoCompleteField}
              search={props.searchCompanies}
              selectedItem={selectedCompany}
              formatItem={result => result && result.name}
              required
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={4}>
            <LocationRadioField name={STORE_OWNER_ID} label="Store Owner" />
          </Col>
          <Col md={4}>
            <LocationRadioField
              name={STORE_LOCATION_ID}
              label="Store Location"
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={3}>
            <PaymentTerms getInitialFieldValue={props.getInitialFieldValue} />
          </Col>
          {isAdmin && (
            <Col md={3}>
              <Field
                name={CONSIGNOR_PERCENTAGE}
                label="Consignor / EMA %"
                placeholder="Enter percentage"
                type="number"
                component={FormInput}
              />
            </Col>
          )}
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  isLastExchange: T.bool,
  nonAccountingUser: T.bool
};

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(actions.update(data)),
  searchCompanies: filter => dispatch(actions.searchCompanies(filter)),
  searchBuyers: filter => dispatch(actions.searchBuyers(filter))
}))(
  form({
    form: "editConsignmentForm"
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/Consignments/Detail/EditConsignment/Form.jsx